module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/product-images/fr-product-06-2962796b25264bf30a191525ef20318a.jpg";